import React from "react"
import { navigate } from "gatsby"
import { listItems } from "../../types/listItems"
import List from "./List/List"
import NavigationLogo from "./NavigationLogo/NavigationLogo"

const DesktopNav = () => {
  return (
    <div className="flex items-center justify-between h-12">
      <NavigationLogo onClick={() => navigate("/")} />
      <List listItems={listItems} />
    </div>
  )
}

export default DesktopNav
